import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ResponsiveContainer, BarChart, Bar, ReferenceLine, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import { Spinner } from 'components';
import * as styles from './SocialMediaSummary.scss';
var PageInsightsPreview = (_dec = connect(function (state, ownProps) {
  return {
    theme: state.theme
  };
}, {}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(PageInsightsPreview, _Component);

  var _super = _createSuper(PageInsightsPreview);

  function PageInsightsPreview() {
    var _this;

    _classCallCheck(this, PageInsightsPreview);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getDataPoints", function (items) {
      var data = items.reduce(function (acc, cur) {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, cur.key, cur.data ? cur.data : {}));
      }, {});
      var sortedAgeGender = Object.keys(data.page_fans_gender_age).sort(function (a, b) {
        return data.page_fans_gender_age[b] - data.page_fans_gender_age[a];
      });
      var sortedLocations = Object.keys(data.page_fans_city).length ? Object.keys(data.page_fans_city).sort(function (a, b) {
        return data.page_fans_city[b] - data.page_fans_city[a];
      }) : null;
      var ageAndGender = sortedAgeGender.length ? sortedAgeGender[0] : null;
      var gender = ageAndGender ? ageAndGender.substring(0, 1) === 'M' ? 'Men' : 'Women' : null;
      var age = ageAndGender ? ageAndGender.substring(2, ageAndGender.length) : null;
      return {
        gender: gender,
        age: age,
        locations: sortedLocations ? [sortedLocations[0], sortedLocations[1], sortedLocations[2]] : null
      };
    });

    _defineProperty(_assertThisInitialized(_this), "renderGraph", function (items) {
      var graphData = [{
        name: '18-24',
        men: 0,
        women: 0
      }, {
        name: '25-34',
        men: 0,
        women: 0
      }, {
        name: '35-44',
        men: 0,
        women: 0
      }, {
        name: '45-54',
        men: 0,
        women: 0
      }, {
        name: '55-64',
        men: 0,
        women: 0
      }, {
        name: '65+',
        men: 0,
        women: 0
      }];
      var data = items.reduce(function (acc, cur) {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, cur.key, cur.data ? cur.data : {}));
      }, {});
      var graphData2;

      if (data && data.page_fans_gender_age) {
        graphData2 = graphData.map(function (thing) {
          Object.keys(data.page_fans_gender_age).forEach(function (key) {
            var graphDataKey = key.substring(2, key.length);

            if (thing.name === graphDataKey) {
              if (key.substring(0, 1) === 'M') {
                thing.men = data.page_fans_gender_age[key];
              } else if (key.substring(0, 1) === 'F') {
                thing.women = data.page_fans_gender_age[key];
              } else if (key.substring(0, 1) === 'U') {
                thing.uncategorized = data.page_fans_gender_age[key];
              }
            }
          });
          return thing;
        });
      }

      return /*#__PURE__*/React.createElement(ResponsiveContainer, null, /*#__PURE__*/React.createElement(BarChart, {
        width: 600,
        height: 300,
        data: graphData2,
        stackOffset: "sign",
        layout: "vertical",
        margin: {
          top: 5,
          right: 30,
          left: 20,
          bottom: 5
        }
      }, /*#__PURE__*/React.createElement(XAxis, {
        type: "number"
      }), /*#__PURE__*/React.createElement(YAxis, {
        dataKey: "name",
        type: "category"
      }), /*#__PURE__*/React.createElement(Tooltip, null), /*#__PURE__*/React.createElement(Legend, null), /*#__PURE__*/React.createElement(ReferenceLine, {
        x: 0,
        stroke: "#000"
      }), /*#__PURE__*/React.createElement(Bar, {
        dataKey: "men",
        fill: _this.props.theme.colors.secondaryColor,
        barSize: 20,
        stackId: "stack"
      }), /*#__PURE__*/React.createElement(Bar, {
        dataKey: "women",
        fill: _this.props.theme.colors.primaryColor,
        barSize: 20,
        stackId: "stack"
      }), /*#__PURE__*/React.createElement(Bar, {
        dataKey: "uncategorized",
        fill: '#333333',
        barSize: 20,
        stackId: "stack"
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "renderStats", function (items) {
      var theme = _this.props.theme;

      var data = _this.getDataPoints(items);

      var showAgeGender = data.gender && data.age && items.find(function (i) {
        return i.key === 'page_fans_gender_age';
      }).value;
      var showCity = data.locations && items.find(function (i) {
        return i.key === 'page_fans_city';
      }).value;
      return /*#__PURE__*/React.createElement("ul", {
        className: styles.listStyle
      }, data.gender && showAgeGender && /*#__PURE__*/React.createElement("li", {
        className: styles.overviewListItem
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.largeText,
        style: {
          color: theme.colors.secondaryColor
        }
      }, data.gender)), data.age && showAgeGender && /*#__PURE__*/React.createElement("li", {
        className: styles.overviewListItem
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.largeText,
        style: {
          color: theme.colors.secondaryColor
        }
      }, data.age)), showCity && /*#__PURE__*/React.createElement("li", {
        className: styles.overviewListItem,
        style: {
          minHeight: 58,
          height: 'auto'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.largeText,
        style: {
          color: theme.colors.secondaryColor
        }
      }, "Lives In"), /*#__PURE__*/React.createElement("ul", {
        className: styles.innerList
      }, data.locations.map(function (item, index) {
        return /*#__PURE__*/React.createElement("li", {
          className: styles.innerListItem,
          key: "location".concat(index)
        }, item);
      }))));
    });

    return _this;
  }

  _createClass(PageInsightsPreview, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          items = _this$props.items,
          loading = _this$props.loading,
          showTopBlurb = _this$props.showTopBlurb,
          topBlurbText = _this$props.topBlurbText,
          style = _this$props.style;
      var showAgeGender = items.find(function (i) {
        return i.key === 'page_fans_gender_age';
      }).value;
      return !loading ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles.wrap, " ").concat(styles.itemPageBreak),
        style: style
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.column
      }, showTopBlurb && /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: 16
        }
      }, topBlurbText), items && !!items.length && this.renderStats(items)), items && !!items.length && showAgeGender && /*#__PURE__*/React.createElement("div", {
        className: styles.column
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: 16,
          fontSize: 18,
          textAlign: 'center'
        }
      }, "Age & Gender Breakdown"), items && items.length && this.renderGraph(items))) : /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative',
          height: 75
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }));
    }
  }]);

  return PageInsightsPreview;
}(Component)) || _class);
export { PageInsightsPreview as default };
PageInsightsPreview.defaultProps = {
  style: {},
  showTopBlurb: true,
  topBlurbText: 'From past ad campaigns and post engagements, we can see that the most common demographic profile interacting with your business is:'
};